import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import { newRate, newValue, rawRate } from '@tool/index';
import HRService from '@service/hr';

const moLeaveRate = observable({
  type: 'chart', // chart, table
  timeList: <string[] | number[]>[],
  activeTime: <number | string>'',
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any>null,
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
});

const initLeaveRateTable = action(async () => {
  const res: any = await HRService.dimissionIndustryAll();
  // console.log('各行业离职率 全部年份 -- ', res);
  if (isEmpty(res)) return;

  let years: any[] = [];
  let tableRight: any[] = [];

  let tempYears: any[] = [];
  res.map((item: any) => {
    tempYears.push(`${item.year}年`);
  });
  years = uniq(tempYears);
  tableRight.push(years);

  moLeaveRate.tableLeft.map((industryV2: any) => {
    let tempArr: any[] = [];
    res.map((item: any) => {
      if ((item.industry_lv1 === industryV2 && item.industry_lv2 === '') || item.industry_lv2 === industryV2) {
        tempArr.push(`${rawRate(item.rate)}`);
      }
    });
    if (!isEmpty(tempArr)) tableRight.push(tempArr);
  });

  // console.log('table right === ', tableRight);

  runInAction(() => {
    moLeaveRate.tableRight = tableRight;
  });
});

const initLeaveRate = action((res: any) => {
  const { type } = moLeaveRate;

  const tempType = localStorage.getItem('indicatorType4') || '';
  if (tempType && (tempType !== type)) moLeaveRate.type = tempType;
  else localStorage.setItem('indicatorType4', type);

  if (isEmpty(res)) return;

  // console.log('------ 行业离职率 ------ ', res);
  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  let tableLeft: any[] = [];
  let tableRight: any[] = [];

  res.data?.map((item: any) => {
    xData.push(item.industry);
    yData.push(item.rate);
    tableLeft.push(item.industry);
  });
  tableLeft.unshift('行业');

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  moLeaveRate.xData = xData;
  moLeaveRate.yData = yData;
  moLeaveRate.overview = overview;
  moLeaveRate.tableLeft = tableLeft;
  moLeaveRate.tableRight = tableRight;
  moLeaveRate.labels = res.total_industry_data || null;

  initLeaveRateTable();
});

const changeType = action((type: string) => {
  moLeaveRate.type = type;
  localStorage.setItem('indicatorType4', type);
});

const changeTimeTab = action((value: string | number) => {
  moLeaveRate.activeTime = value;
});

export default moLeaveRate;
export {
  initLeaveRate, initLeaveRateTable,
  changeType, changeTimeTab,
};
